import React, { useState } from 'react';
import { FiX, FiTrash2 } from 'react-icons/fi';

interface RejectApplicationModalProps {
  applicantName: string;
  onConfirm: (notifyApplicant: boolean) => void;
  onCancel: () => void;
}

export const RejectApplicationModal: React.FC<RejectApplicationModalProps> = ({
  applicantName,
  onConfirm,
  onCancel,
}) => {
  const [notifyApplicant, setNotifyApplicant] = useState(true);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div
        className="w-full max-w-[440px] bg-[#0c0c0c] border border-white/10 rounded-[28px] overflow-hidden shadow-2xl"
        style={{ animation: 'fadeInScale 0.2s ease-out' }}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-6">
          <h3 className="text-white text-[17px] font-semibold">Reject application?</h3>
          <button
            onClick={onCancel}
            className="p-1.5 text-zinc-500 hover:text-white transition-colors rounded-full hover:bg-white/5"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="flex flex-col items-center px-6 pt-8 pb-6">
          {/* Trash icon */}
          <div className="w-16 h-16 rounded-full bg-red-900/40 flex items-center justify-center mb-6">
            <FiTrash2 size={28} className="text-red-400" />
          </div>

          <p className="text-white text-[18px] font-semibold text-center mb-8 leading-relaxed">
            Are you sure you want to reject this application?
          </p>
          <p className="text-zinc-400 text-sm text-center mb-8">{applicantName}</p>

          {/* Notify toggle */}
          <div className="w-full flex items-center justify-between px-5 py-4 rounded-2xl border border-white/10 bg-white/[0.03]">
            <span className="text-white text-[15px] font-medium">Notify Applicant</span>
            <button
              type="button"
              onClick={() => setNotifyApplicant(!notifyApplicant)}
              className={`relative w-12 h-7 rounded-full transition-colors duration-200 ${
                notifyApplicant ? 'bg-blue-500' : 'bg-zinc-700'
              }`}
              role="switch"
              aria-checked={notifyApplicant}
              aria-label="Notify Applicant"
            >
              <span
                className="absolute top-0.5 left-0.5 w-6 h-6 rounded-full bg-white shadow-md transition-transform duration-200"
                style={{ transform: notifyApplicant ? 'translateX(20px)' : 'translateX(0px)' }}
              />
            </button>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3 px-6 pb-6">
          <button
            onClick={onCancel}
            className="flex-1 h-12 rounded-full border border-white/15 text-white text-[15px] font-semibold hover:bg-white/5 transition-all active:scale-[0.97]"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(notifyApplicant)}
            className="flex-1 h-12 rounded-full bg-white text-black text-[15px] font-semibold hover:bg-zinc-200 transition-all active:scale-[0.97] flex items-center justify-center gap-2"
          >
            <FiX size={16} className="text-red-500" />
            Reject
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeInScale {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};
